import React, { useEffect, useState } from "react";
import { assessmentReportPartnerHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import Loader from "../ReusableComponents/Loader";
import GridPage from "../components/GridPage";
import { BindPostAPI } from "../services/APIConnection";

const AssessmentReportPartner = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [buttonEnable, setButtonEnable] = useState(null);
  const [assessmentReportPartnerData, setAssessmentReportPartnerData] =
    useState([]);
    const [showFileModal, setShowFileModal] = useState(false);
      const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const partnerId = sessionStorage.getItem("partnerId");
  useEffect(() => {
    AssessmentReportPartnerData();
  }, []);

  const AssessmentReportPartnerData = async () => {
    setIsLoading(true);
    const data = {
      MstPartnerId: parseInt(partnerId, 10),
    };
    const response = await BindPostAPI(
      data,
      "AssessmentReportAPI/BindAssessmentReportPartner"
    );

    setAssessmentReportPartnerData(response.data.Table);
    if (response.data.Table.length === 0) {
      setButtonEnable(false);
    } else {
      setButtonEnable(true);
    }
    setIsLoading(false);
  };
  const handleViewFile = (rowIndex, flag, file) => {
    debugger;
    // if (file == 1) {
      const rowData = assessmentReportPartnerData[rowIndex].AttachmentFile;
      setSelectedFileUrl(rowData);
    // } else if (file == 2) {
    //   const rowData = assessmentReportPartnerData[rowIndex].TaxInvoice;
    //   setSelectedFileUrl(rowData);
    // }

    setShowFileModal(true);
  };
   const isImageFile = (url) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
    const ext = url?.split(".").pop()?.toLowerCase();
    return imageExtensions.includes(ext);
  };
  const getViewerUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();

    return extension === "pdf"
      ? url
      : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          url
        )}`;
  };
  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {/* {assessmentReportPartnerData == [] && (
        <div className="border p-4 rounded-md shadow-sm">
          <div className="mb-2 text-xs text-red-500 italic flex justify-center">
            You have already submited the answer for assessment.
          </div>
        </div>
      ):(
      <GridPage
        title="Assessment Report"
        addView={true}
        header={assessmentReportPartnerHeader}
        records={assessmentReportPartnerData}
        handleAction={handleAssessmentDownload}
      />
      )} */}
      {buttonEnable != null && !buttonEnable && (
        <>
        <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4 text-xl font-medium text-neutral-700">
            Assessment Report
          </div>
        <div className="border p-4 lg:mx-4 rounded-md shadow-sm">
          <div className="mb-2 text-xs text-red-500 italic flex justify-center">
            Assessment report is yet to be generated and you will receive an
            email notification once the assessment report is uploaded to this
            portal.
          </div>
        </div>
        </>
      )}
      {buttonEnable != null && buttonEnable && (
        <GridPage
          title="Assessment Report"
          addView={true}
          header={assessmentReportPartnerHeader}
          records={assessmentReportPartnerData}
          onViewFile={handleViewFile}
        />
      )}
      {showFileModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowFileModal(false)} // Outside click closes modal
        >
          <div
            className="bg-white p-6 rounded shadow-lg max-w-4xl w-full h-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
          >
            <button
              onClick={() => setShowFileModal(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>
            {selectedFileUrl ? (
              isImageFile(selectedFileUrl) ? (
                <img
                  src={selectedFileUrl}
                  alt="Preview"
                  className="w-full h-full object-contain rounded"
                />
              ) : (
                <iframe
                  src={getViewerUrl(selectedFileUrl)}
                  title="File Viewer"
                  className="w-full h-[80vh] rounded"
                />
              )
            ) : (
              <div className="text-center text-gray-500">No file selected</div>
            )}
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default AssessmentReportPartner;
